var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('Header'),_c('div',{staticClass:"content-container",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"sub-content-container"},[_c('div',{staticClass:"content-box"},[_c('ArticleDetail',{attrs:{"articleId":_vm.articleId,"showBreadcrumb":true}})],1)])]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }